export const BASE_URL = "https://api.dhangadhiskincare.com"